import Vue from 'vue';
import users from '../../../users';
import axios from 'axios';
import moment from 'moment';
import createDateForBackEnd from '@/employee/omApplications/common/omApplicationTools';

export default {
  name: 'Stores',
  components: {
    StoreComp: require('./store.vue').default,
  },
  mixins: [createDateForBackEnd, users],
  props: ['dataObj'],
  data: function () {
    return {
      sourceId: -1,
      employeeUsage: 1,
      storeUsageSourceTypes: [],
      warehousesSource: [],
      warehousesDestination: [],
      itemsInventory: [],
      stores: [],
      editingStore: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showStore: false,
      totalRow: 0,
      bInitialized: false,
      bPageChange: true,
    }
  },
  computed: {
    startDateTime: function () {
      return this.dataObj.startDateTime;
    },
    dateFromHH: function () {
      return this.dataObj.dateFromHH;
    },
    dateFromMin: function () {
      return this.dataObj.dateFromMin;
    },
  },
  created() {
    this.getStoreLookups();
    this.getInventory();
    this.getWarehouses();
    this.init();
    //this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  methods: {
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      if (this.bPageChange === true)
        this.bPageChange = false
      else
        this.getStores();
    },
    init() {
      Vue.nextTick(() => {
        this.bInitialized = false;
        this.sourceId = this.dataObj.dataChildren ? this.dataObj.dataChildren.sourceId : this.sourceId;
        this.employeeUsage = this.dataObj.dataChildren ? this.dataObj.dataChildren.empUsage : this.employeeUsage;
        this.getStores();
      });
    },
    getItemText(iKey) {
      return (this.itemsInventory.filter(t => t.itemId == iKey).length > 0) ? this.itemsInventory.filter(t => t.itemId == iKey)[0].name : '';
    },
    getWHSourceText(iKey) {
      return (this.warehousesSource.filter(t => t.id == iKey).length > 0) ? this.warehousesSource.filter(t => t.id == iKey)[0].name : '';
    },
    getWHDestText(iKey) {
      return (this.warehousesDestination.filter(t => t.id == iKey).length > 0) ? this.warehousesDestination.filter(t => t.id == iKey)[0].name : '';
    },
    getStoreLookups() {
      axios.post('/Om/GetStoreLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.storeUsageSourceTypes = response.data.storeUsageSourceTypes;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getStoreLookups');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getInventory() {
      var parameter = {
        GroupId: 0,
        IsOnlyAvailableItems: false,
        WarehouseId: 0,
        ListOptions: { pageSize: 10000, total: 0, page: 1, filterText: null }
      };
      axios.post('/Om/GetAvailableStoreItems', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.itemsInventory = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getInventory');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getWarehouses() {
      axios.post('/Om/GetWarehouses', { Value: -1 })
        .then(response => {
          if (response.data.data.status == 0) {
            this.warehousesSource = response.data.items;
            this.warehousesDestination = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getWarehouses');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getStores() {
      this.bInitialized = false;
      var parameters = { SourceType: this.employeeUsage, SourceId: this.sourceId};
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetStoreAllocations', parameters),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.stores = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
            this.bInitialized = this.sourceId > 0;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Store Allocations'
      );
    },
    add() {
      this.editingStore = {
        allocationId: -1,
        sourceType: this.employeeUsage,
        sourceId: this.sourceId,
        scheduledDateTime: this.startDateTime,
        scheduledTimeHH: this.dataObj.dateFromHH,
        scheduledTimeMin: this.dataObj.dateFromMin,
        itemId: -1,
        item: { itemId: -1, name: '' },
        name: '',
        takenQuantity: 0,
        usedQuantity: 0,
        comment: '',
        sourceWareHouseId: 0,
        destinationWareHouseId: 0,
        readonly: false,
        storeUsageSourceTypes: this.storeUsageSourceTypes,
        itemsInventory: this.itemsInventory,
        warehousesSource: this.warehousesSource,
        warehousesDestination: this.warehousesDestination,
        stations: this.stations
      };

      var preferenceData = this.$localStorage.get('_preference');
      this.preference = JSON.parse(preferenceData);

      if (this.preference.linkToWarehouse == true) {
        this.editingStore.sourceWareHouseId = this.preference.warehouseId;
        this.editingStore.destinationWareHouseId = this.preference.warehouseId;
      }

      this.$root.$emit('store_updated');
      this.showStore = true;
    },
    edit(store) {
      this.editingStore = store;
      this.editingStore.item = { itemId: -1, name: '' }; 
      this.editingStore.storeUsageSourceTypes = this.storeUsageSourceTypes;
      this.editingStore.itemsInventory = this.itemsInventory;
      this.editingStore.warehousesSource = this.warehousesSource;
      this.editingStore.warehousesDestination = this.warehousesDestination;
      this.editingStore.stations = this.stations;
      this.editingStore.readonly = false;

      this.editingStore.scheduledTimeHH = moment(this.editingStore.scheduledDateTime).format('HH');
      this.editingStore.scheduledTimeMin = moment(this.editingStore.scheduledDateTime).format('mm');

      this.$root.$emit('store_updated');
      this.showStore = true;
    },
    saveStore() {
      if (!this.editingStore.scheduledDateTime || !this.editingStore.scheduledTimeHH || !this.editingStore.scheduledTimeMin) {
        this.$alertMsg(this.$t('jobcard.DateComplete'), 4);
        return;
      }

      var sUrl = (this.editingStore.allocationId == -1) ? '/Om/AddStoreAllocation' : '/Om/UpdateStoreAllocation';
      this.editingStore.itemId = this.editingStore.item.itemId;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      let param = {
        SourceType: this.editingStore.sourceType,
        SourceId: this.editingStore.sourceId,
        ItemId: this.editingStore.itemId,
        AllocationId: this.editingStore.allocationId,
        ScheduledDateTime: this.createDateForBackEnd(this.editingStore.scheduledDateTime),
        ScheduledDateHours: this.editingStore.scheduledTimeHH,
        ScheduledDateMinutes: this.editingStore.scheduledTimeMin,
        Comment: this.editingStore.comment,
        SourceWareHouseId: this.editingStore.sourceWareHouseId,
        DestinationWareHouseId: this.editingStore.destinationWareHouseId
      }

      if (this.editingStore.takenQuantity)
        param['TakenQuantity'] = this.editingStore.takenQuantity;

      if (this.editingStore.usedQuantity)
        param['UsedQuantity'] = this.editingStore.usedQuantity;

      axios.post(sUrl, param)
        .then(response => {
          if (response.data.data.status == 0) {
            this.getStores();
            this.$alertMsg(this.$t('messages.StoreSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)

          loader.hide();
          this.showStore = false;
        })
        .catch((e) => {
          console.log('saveStore');
          console.log(e);
          loader.hide();
          this.$alertMsg(e.message)
        })
    },
    remove(id) {
      axios.post('/Om/RemoveStoreAllocations', { SourceType: this.employeeUsage, SourceId: this.sourceId, AllocationId: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.StoreDeletedSuccess'), 2);
            this.getStores();
          }
        })
        .catch((e) => { this.$alertMsg(e.message) })
    },
    closeDialog() {
      this.editingMessage = '';
      this.getStores();
      this.showStore = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getStores();
    },
  },
  
}

